var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content importingTemplate" },
    [
      _c("div", { staticClass: "grid-view" }, [
        _c("div", { staticClass: "main-content" }, [
          _c(
            "div",
            {
              staticClass: "section operations",
              staticStyle: { height: "39px" }
            },
            [
              _c("div", { staticClass: "triggers" }, [
                _c(
                  "div",
                  [
                    _c(
                      "span",
                      {
                        staticStyle: {
                          display: "inline-block",
                          width: "50px",
                          color: "#333333"
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("common.btn.query")))]
                    ),
                    _c("el-input", {
                      staticStyle: { width: "286px" },
                      attrs: {
                        placeholder: _vm.$t("CargoMsg.Cargo_PleaseQuery")
                      },
                      model: {
                        value: _vm.inputVal,
                        callback: function($$v) {
                          _vm.inputVal = $$v
                        },
                        expression: "inputVal"
                      }
                    }),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "mini" },
                        on: {
                          click: function($event) {
                            return _vm.query(false)
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("common.btn.query")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "mini" },
                        on: { click: _vm.add }
                      },
                      [_vm._v(_vm._s(_vm.$t("common.btn.new")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "primary",
                          disabled:
                            _vm.selectedCount === 0 ||
                            (_vm.tenantId === 1 &&
                              _vm.$store.getters.tenantId !== 1),
                          size: "mini"
                        },
                        on: { click: _vm.edit }
                      },
                      [_vm._v(_vm._s(_vm.$t("common.btn.edit")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "primary",
                          disabled: _vm.selectedCount === 0,
                          size: "mini"
                        },
                        on: { click: _vm.copy }
                      },
                      [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Copy")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "danger",
                          disabled:
                            !_vm.isChecked ||
                            (_vm.tenantId === 1 &&
                              _vm.$store.getters.tenantId !== 1),
                          size: "mini"
                        },
                        on: { click: _vm.deletes }
                      },
                      [_vm._v(_vm._s(_vm.$t("common.btn.delete")))]
                    ),
                    _vm.$store.getters.tenantId !== 1
                      ? _c(
                          "el-checkbox",
                          {
                            staticStyle: { "margin-left": "10px" },
                            on: { change: _vm.prefabrication },
                            model: {
                              value: _vm.checked,
                              callback: function($$v) {
                                _vm.checked = $$v
                              },
                              expression: "checked"
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("CargoMsg.Cargo_HiddenPlatform"))
                            )
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ])
            ]
          ),
          _c(
            "div",
            {
              staticClass: "section grid-wrapper",
              staticStyle: { "min-height": "350px" }
            },
            [
              _c("cargo-ag-grid", {
                attrs: {
                  "config-module": "191263",
                  "grid-options": _vm.gridOptions,
                  "column-defs": _vm.columnDefs,
                  "row-data": _vm.rowData
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination-wrapper" },
            [
              _c("cargo-pagination", {
                attrs: {
                  "config-module": "022060523",
                  total: _vm.searchConditions.total,
                  page: _vm.searchConditions.pageNum,
                  limit: _vm.searchConditions.pageSize
                },
                on: {
                  "update:page": function($event) {
                    return _vm.$set(_vm.searchConditions, "pageNum", $event)
                  },
                  "update:limit": function($event) {
                    return _vm.$set(_vm.searchConditions, "pageSize", $event)
                  },
                  pagination: function($event) {
                    return _vm.query(true)
                  }
                }
              })
            ],
            1
          )
        ])
      ]),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.newPlan,
            "close-on-click-modal": false,
            title: _vm.$t("CargoMsg.Cargo_AddNewTemplate"),
            editable: true,
            "modal-append-to-body": false,
            width: "800px;"
          },
          on: {
            "update:visible": function($event) {
              _vm.newPlan = $event
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "app-main-inner-row",
              staticStyle: {
                "padding-bottom": "10px",
                display: "flex",
                "flex-direction": "column"
              }
            },
            [
              _c(
                "div",
                { staticClass: "filters" },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        inline: true,
                        model: _vm.dialogForm,
                        "label-position": "left"
                      },
                      nativeOn: {
                        submit: function($event) {
                          $event.preventDefault()
                        }
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "setStyle",
                          attrs: { label: _vm.$t("CargoMsg.Cargo_ProductName") }
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "180px" },
                            attrs: {
                              type: "text",
                              placeholder: _vm.$t(
                                "CargoMsg.Cargo_PleaseEnterPlanName"
                              )
                            },
                            model: {
                              value: _vm.dialogForm.templateName,
                              callback: function($$v) {
                                _vm.$set(_vm.dialogForm, "templateName", $$v)
                              },
                              expression: "dialogForm.templateName"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { "margin-left": "20px" },
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_PlanDescription")
                          }
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "180px" },
                            attrs: {
                              type: "text",
                              placeholder: _vm.$t(
                                "CargoMsg.Cargo_PleaseEnterPlanRemark"
                              )
                            },
                            model: {
                              value: _vm.dialogForm.templateDescribe,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.dialogForm,
                                  "templateDescribe",
                                  $$v
                                )
                              },
                              expression: "dialogForm.templateDescribe"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                display: "block",
                                margin: "20px 0",
                                color: "#000"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("CargoMsg.Cargo_ImportTableSet"))
                              )
                            ]
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "setStyle",
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_StartLine2")
                              }
                            },
                            [
                              _c("el-input", {
                                style: { width: _vm.isZh ? "100px" : "200px" },
                                attrs: {
                                  type: "number",
                                  placeholder: _vm.$t(
                                    "CargoMsg.Cargo_PleaseEnterStartLine"
                                  )
                                },
                                model: {
                                  value: _vm.dialogForm.startRow,
                                  callback: function($$v) {
                                    _vm.$set(_vm.dialogForm, "startRow", $$v)
                                  },
                                  expression: "dialogForm.startRow"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "align-items": "center"
                          }
                        },
                        [
                          _c(
                            "el-checkbox",
                            {
                              on: { change: _vm.changed },
                              model: {
                                value: _vm.dialogForm.openFilterRule,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.dialogForm,
                                    "openFilterRule",
                                    $$v
                                  )
                                },
                                expression: "dialogForm.openFilterRule"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("CargoMsg.Cargo_EnableFilterRowRule")
                                )
                              )
                            ]
                          ),
                          _c(
                            "el-tooltip",
                            {
                              staticClass: "item",
                              attrs: {
                                effect: "dark",
                                content: _vm.$t(
                                  "CargoMsg.Cargo_ImportColumnsFilterOut"
                                ),
                                placement: "top-end"
                              }
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-question",
                                staticStyle: {
                                  color: "#46a6ff",
                                  "margin-bottom": "10px"
                                }
                              })
                            ]
                          ),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.dialogForm.openFilterRule,
                                  expression: "dialogForm.openFilterRule"
                                }
                              ],
                              staticStyle: { "margin-left": "20px" }
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("CargoMsg.Cargo_SpaceGreaterThan")
                                  )
                                )
                              ]),
                              _c("el-input", {
                                staticStyle: {
                                  width: "50px",
                                  margin: "0 10px"
                                },
                                attrs: { type: "number" },
                                model: {
                                  value: _vm.dialogForm.blankAccountFor,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.dialogForm,
                                      "blankAccountFor",
                                      $$v
                                    )
                                  },
                                  expression: "dialogForm.blankAccountFor"
                                }
                              }),
                              _vm._v(" % ")
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticStyle: { "margin-top": "20px" } },
                [
                  _c(
                    "p",
                    { staticStyle: { color: "red", margin: "0 0 5px 0" } },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("CargoMsg.Cargo_PleaseEnterHeaderName"))
                      )
                    ]
                  ),
                  _c(
                    "p",
                    { staticStyle: { color: "red", margin: "0 0 5px 0" } },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t("CargoMsg.Cargo_PleaseEnterHeaderGridNum")
                        )
                      )
                    ]
                  ),
                  _c("cargo-ag-grid", {
                    attrs: {
                      "config-module": "191264",
                      "grid-options": _vm.dialogGridOptions,
                      "column-defs": _vm.dialogColumnDefs,
                      "row-data": _vm.dialogForm.templateMappingVoList
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "space-between",
                    "margin-top": "20px"
                  }
                },
                [
                  _c(
                    "div",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", size: "mini" },
                          on: { click: _vm.dialogAdd }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_add")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "danger",
                            size: "mini",
                            disabled: !_vm.dialogSelectedCount
                          },
                          on: { click: _vm.dialogDelete }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Delete")))]
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", size: "mini" },
                          on: {
                            click: function($event) {
                              return _vm.dialogConfirm()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ConfirmR")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "mini" },
                          on: {
                            click: function($event) {
                              return _vm.dialogCancel()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
                      )
                    ],
                    1
                  )
                ]
              )
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }